<script setup lang="ts">
import BaseHeader from "@/components/Header/BaseHeader.vue";
import type { LayoutProps } from "./types";

const props = withDefaults(defineProps<LayoutProps>(), {
  ldClient: "",
  logoUrl: "",
  logoUrlSquare: "",
});
</script>

<template>
  <base-header :ld-client="props.ldClient" :logo="props.logoUrl" />

  <div class="w-full mx-auto h-full md:flex md:flex-col">
    <main>
      <slot />
    </main>
  </div>
</template>

